export const  scrollToBottom=(scrollRef)=> {
    console.log(scrollRef.current)
    if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        console.log('Scrolled to bottom!');
    }
}